import React from 'react';
import { Envelope, SignOut, UserMinus } from '@phosphor-icons/react';
import { SettingsLine } from './SettingsLine';
import { useAuth } from '../../../shared/contexts/AuthContext';
import type { User } from 'firebase/auth';

interface AccountSectionProps {
  onLogout: () => void;
  onDeleteRequest: () => void;
}

export function AccountSection({ onLogout, onDeleteRequest }: AccountSectionProps) {
  const { user } = useAuth();
  const isGoogleUser = (user as User)?.providerData?.[0]?.providerId === 'google.com';

  return (
    <div>
      <h3 className="text-xs font-semibold uppercase tracking-wider text-[#361e06] mb-4">Account</h3>
      
      <div>
        <SettingsLine 
          label="Email" 
          icon={Envelope}
        >
          <div className="flex items-center">
            <span className="text-[#361e06]">{user?.email}</span>
            {isGoogleUser && (
              <img 
                src="/google-logo.png" 
                alt="Google" 
                className="ml-2 h-4 w-4"
              />
            )}
          </div>
        </SettingsLine>

        <SettingsLine 
          label="Permanently delete your account" 
          icon={UserMinus}
        >
          <button
            onClick={onDeleteRequest}
            className="text-sm font-medium text-red-600 hover:text-red-700"
          >
            Delete account
          </button>
        </SettingsLine>

        <SettingsLine 
          label="Sign out" 
          icon={SignOut}
          isLast={true}
        >
          <button
            onClick={onLogout}
            className="text-sm font-medium text-blue-600 hover:text-blue-700"
          >
            Sign out
          </button>
        </SettingsLine>
      </div>
    </div>
  );
} 